import React, { useState, useRef, useEffect } from 'react';
import MapContext from './MapContext';
import './Map.css';
import {defaults as defaultInteractions} from 'ol/interaction.js';
// import * as ol from 'ol';

import Map  from 'ol/Map';
import View  from 'ol/View';

const _Map = ({children, zoom, center,disabled, setCenter}) => {

    const mapRef = useRef();
    const [map, setMap] = useState(null);

    //mount
    useEffect(() => {
        let options = {
            view: new View({zoom, center}),
            layers: [],
            controls: [],
            overlays: []
        };

       if( disabled ) {
            options.interactions = defaultInteractions({
                doubleClickZoom: false,
                dragAndDrop: false,
                dragPan: false,
                keyboardPan: false,
                keyboardZoom: false,
                mouseWheelZoom: false,
                pointer: false,
                select: false
              })
       }

        let mapObject = new Map(options);
        mapObject.setTarget(mapRef.current);

        setMap(mapObject);

        return () => mapObject.setTarget(undefined);
    }, [disabled])

    // zoom 
    useEffect(() => {
        if (!map) return;
        map.getView().setZoom(zoom);
      }, [zoom]);

    //center change
    useEffect(() => {
        if (!map) return;
        if( ! map.getView().get('center') ) {
            map.getView().setCenter(center)

        }

      }, [center])

    return (
        <MapContext.Provider value={{map}}>
            <div ref={mapRef} className='ol-map'>
            {children}
            </div>
        </MapContext.Provider>

    )
}

export default _Map;